import * as React from 'react';



export default class CloseActivity extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-236.000000, -225.000000)">
            <g id="Group-74" transform="translate(236.000000, 225.000000)">
                <g id="Group-12" transform="translate(1.000000, 1.000000)">
                    <g id="Page-1">
                        <polyline id="Stroke-1" points="2.25 5.3994 5.16666667 9.0834 13.6246667 2.0834"></polyline>
                        <path d="M7.45833333,0.333333333 L0.982333333,0.333333333 C0.624333333,0.333333333 0.333,0.624 0.333,0.982666667 L0.333,12.934 C0.333,13.2926667 0.624333333,13.5833333 0.982333333,13.5833333 L12.6796667,13.5833333 C13.0376667,13.5833333 13.329,13.2926667 13.329,12.934 L13.329,8.5" id="Stroke-3"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
